var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgConversationType = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M47.31 38.22c-.49 2.34-1.18 4.64-2.01 6.89-.28.77-.58 1.53-.93 2.27-.16.32-.34.83-.66 1.02-.35.22-.52-.47-.55-.67-.17-.96-.49-1.92-.86-2.81-.1-.23-.6-1.46-.75-1.5-.21-.05-1.23.78-1.45.9-.51.27-1.03.5-1.57.69-1.11.41-2.27.69-3.44.83-3.8.44-8.32-.28-11.03-3.21-2.37-2.56-3.14-6.45-2.69-9.83.49-3.64 2.5-6.96 5.47-9.13 3.46-2.54 7.89-3.14 12.06-2.54 2.64.56 4.85 2.18 6.43 4.34 1.29 1.76 2.2 3.84 2.51 6.01.33 2.23-.07 4.56-.53 6.75Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 16,
  y: 16,
  width: 13.7,
  height: 4.03,
  rx: 2,
  ry: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 16,
  y: 21.99,
  width: 6.85,
  height: 4.03,
  rx: 2,
  ry: 2
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgConversationType);
export default ForwardRef;